export default __webpack_public_path__ + "static/media/arrow_drop_down_24px.fc93d66b.svg";